import { PdfGeneratorPageOptions, PdfGeneratorPageRegion } from "../types"
import { PdfGeneratorNormalizedRunningSlot } from "./normalizePdfRunningSlot"

const REGION_TO_AT_RULE: Record<PdfGeneratorPageRegion, string> = {
  "top-left": "@top-left",
  "top-center": "@top-center",
  "top-right": "@top-right",
  "bottom-left": "@bottom-left",
  "bottom-center": "@bottom-center",
  "bottom-right": "@bottom-right"
}

const REGION_VERTICAL_ALIGN: Record<PdfGeneratorPageRegion, string> = {
  "top-left": "bottom",
  "top-center": "bottom",
  "top-right": "bottom",
  "bottom-left": "top",
  "bottom-center": "top",
  "bottom-right": "top"
}

export type BuildPdfPageLayoutCssOptions = {
  page?: PdfGeneratorPageOptions
  header?: PdfGeneratorNormalizedRunningSlot | null
  footer?: PdfGeneratorNormalizedRunningSlot | null
}

export const buildPdfPageLayoutCss = (
  options: BuildPdfPageLayoutCssOptions
): string => {
  const { page, header, footer } = options
  const sideMargin = page?.margin ?? "0.5in"
  const marginTop = header ? header.marginSize : sideMargin
  const marginBottom = footer ? footer.marginSize : sideMargin

  const runningRules: string[] = []

  const appendRunningSlot = (slot: PdfGeneratorNormalizedRunningSlot) => {
    runningRules.push(
      `[data-pdf-running="${slot.runningId}"] {`,
      `  position: running(${slot.runningId});`,
      `  width: 100%;`,
      `}`
    )
  }

  if (header) {
    appendRunningSlot(header)
  }

  if (footer) {
    appendRunningSlot(footer)
  }

  const pageRules: string[] = ["@page {"]
  pageRules.push(`  size: ${page?.size ?? "8.5in 11in"};`)

  if (page?.background) {
    pageRules.push(`  background: ${page.background};`)
  }

  pageRules.push(
    `  margin: ${marginTop} ${sideMargin} ${marginBottom} ${sideMargin};`
  )

  if (header) {
    const atRule = REGION_TO_AT_RULE[header.region]
    pageRules.push(`  ${atRule} {`)
    pageRules.push(`    content: element(${header.runningId});`)
    pageRules.push(
      `    vertical-align: ${REGION_VERTICAL_ALIGN[header.region]};`
    )
    pageRules.push(`  }`)
  }

  if (footer) {
    const atRule = REGION_TO_AT_RULE[footer.region]
    pageRules.push(`  ${atRule} {`)
    pageRules.push(`    content: element(${footer.runningId});`)
    pageRules.push(
      `    vertical-align: ${REGION_VERTICAL_ALIGN[footer.region]};`
    )
    pageRules.push(`  }`)
  }

  pageRules.push("}")

  return [...runningRules, ...pageRules].join("\n")
}
